import React from 'react';
import styled from 'styled-components';
import { Overlay } from 'react-bootstrap';
import useOnclickOutside from 'react-cool-onclickoutside';
import useWireToolsStore from '../../wire/wire-tools/state-hooks';
import dt from '../../../shared/theme';
import {
  Button,
  Container,
  Description,
  HintTooltip,
  Title,
} from '../../shared/hint/styles';

const SHintTooltip = styled(HintTooltip)`
  inset: 12px auto auto 0 !important;

  & > .arrow {
    top: -18px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid ${props => dt(props).theme.bodyColor};
    left: 24px !important;
    transform: none !important;
  }
`;

const SDescription = styled(Description)`
  .icon-lw-liked {
    position: absolute;
    margin-top: -2px;
    margin-left: 2px;
  }
`;

const LikeHint = React.forwardRef((_props, ref) => {
  const set = useWireToolsStore(state => state.set);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setShow(true), 1000);
  }, []);

  const hide = e => {
    e && e.preventDefault() && e.stopPropagation();

    setShow(false);

    set(state => {
      state.commentLikeHintShown = true;
    });
  };

  const hintRef = useOnclickOutside(() => {
    hide();
  });

  return (
    <div ref={hintRef}>
      <Overlay target={ref.current} show={show} placement="bottom-start">
        {props => (
          <SHintTooltip className="ignore-onclickoutside" {...props}>
            <Container>
              <Title>
                You can now &ldquo;like&rdquo; comments
                <span className="icon-lw icon-lw-info-circle" />
              </Title>
              <SDescription>
                Show your support for contributors and readers comments by
                clicking the &lsquo;like&rsquo; icon
                <span className="icon-lw icon-lw-liked" />
              </SDescription>
              <Button onClick={hide}>Got it</Button>
            </Container>
          </SHintTooltip>
        )}
      </Overlay>
    </div>
  );
});

export default LikeHint;
